import { Fragment, useState } from 'react';
import Modal, { ModalProps } from './Modal';

import Button from '../common/Button';
import { ModalResponse } from '../../enum/ModalResponse';
import { useTranslation } from 'react-i18next';

export interface ModalInformationProps extends ModalProps {}
export default function ModalDeleteMeter({
  isOpen,
  onClickAction,
  onClose,
}: ModalInformationProps) {
  const { t } = useTranslation();
  const [modalResponse, setModalResponse] = useState<ModalResponse>();

  const handleClickDelete = () => {
    setModalResponse(ModalResponse.OK);
    if (onClickAction) {
      onClickAction(ModalResponse.OK);
    }
  };

  const handleClickCancel = () => {
    setModalResponse(ModalResponse.CANCEL);
    if (onClickAction) {
      onClickAction(ModalResponse.CANCEL);
    }
  };

  const handleClose = (modalResponse: ModalResponse | undefined) => {
    if (onClose) {
      onClose(modalResponse);
    }
  };

  return (
    <Modal
      isOpen={isOpen}
      onClose={() => handleClose(modalResponse)}
      actions={
        <Fragment>
          <Button className="btn btn--secondary" onClick={handleClickCancel}>
            {t('common.cancel')}
          </Button>
          <Button className="btn btn--primary" onClick={handleClickDelete}>
            {t('common.next')}
          </Button>
        </Fragment>
      }
    >
      <Fragment>
        <p className="modal__message">{t('modal.meter.delete.message.one')}</p>

        <p className="modal__message">{t('modal.meter.delete.message.two')}</p>
      </Fragment>
    </Modal>
  );
}
